// extracted by mini-css-extract-plugin
module.exports = {"Slide":"ProductSlide_Slide__1mX1G","ImageContainer":"ProductSlide_ImageContainer__1E1xI","SlideText":"ProductSlide_SlideText__EDL9y"};